<div class="badge"
    [ngClass]="{'dark-secondary': color === 'dark-secondary'}"
    (click)="showWallet()">
  <ion-icon src="assets/SoccerCoin.svg"></ion-icon>
  <div *ngIf="coins !== null">{{ coins }}</div>
</div>